import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Zap } from "lucide-react";
import { CONTACT } from "@/lib/site";

function scrollToDevis() {
  const el = document.getElementById("devis");
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export default function MobileCtaBar() {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const onScroll = () => setShown(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {shown && (
        <motion.div
          initial={{ y: 96, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 96, opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          data-testid="mobile-cta-bar"
          className="fixed inset-x-0 bottom-0 z-[45] lg:hidden"
          style={{ paddingBottom: "calc(10px + env(safe-area-inset-bottom, 0px))" }}
        >
          <div className="glass border-t border-line px-4 pt-2.5">
            <div className="mx-auto grid max-w-md grid-cols-2 gap-2.5">
              <a
                data-testid="mobile-cta-call"
                href={CONTACT.phoneHref}
                className="flex items-center justify-center gap-2 rounded-full border border-line bg-ink/80 px-4 py-3.5 text-[13px] font-extrabold uppercase tracking-wider text-white transition-colors duration-200 active:border-neon active:text-neon"
              >
                <Phone size={16} className="text-neon" />
                Appeler
              </a>
              <button
                data-testid="mobile-cta-devis"
                onClick={scrollToDevis}
                className="flex items-center justify-center gap-2 rounded-full bg-neon px-4 py-3.5 text-[13px] font-extrabold uppercase tracking-wider text-night chip-glow transition-transform duration-200 active:scale-[0.98]"
              >
                <Zap size={16} />
                Devis gratuit
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
